<template>
  <div class="contacts-panel" :class="'cols' + mcolumns">
    <transition name="fade">
      <div class="contact-lightbox" v-show="selcontact > 0" v-on:click.stop="hideContact"></div>
    </transition>
    <div class="contacts-holder" ref="cholder">
      
      <div v-for="(contact, index) in contacts" :key="contact.contact_id" class="contact-block" :class="{sel: selcontact == contact.contact_id}" v-on:click.stop>
        <div class="contact-wrapper">
          <div class="bgimage" v-on:click="showContact(contact.contact_id, $event)">
            <placed-image :url="'contacts/' + contact.contact_id + '.jpg'" fill />
          </div>
          
          <div class="mini-contact-roll" v-if="showroll && (!agent)">
            <div class="mini-name">{{ contact.name }}</div>
            
            <div class="mini-contact-subpanel" >
              <div class="mini-tel" v-if="!hidetel">
                <div v-if="getTel(contact)">
                  <div v-if="getAgentType(contact) == 'Accounts'" style="color:#000">
                    Accounts
                  </div>
                  <strong>T</strong> &nbsp;<a :href="'tel:' + getTel(contact)" v-on:click="$k.sendAgentCallEvent(contact.name)">{{ getTel(contact) }}</a>
                  
                </div>
              </div>
              <a class="icon mail" :href="'mailto:' + contact.email" v-on:click.prevent="handleEmailAgent(contact)"></a>
            </div>
          </div>
        </div>
        
        <transition name="fade">
          <div v-show="selcontact === contact.contact_id" class="pop-info" :style="getPopClass(index)">
            <div class="close-box small" v-on:click="hideContact"></div>
            <div class="pop-image">
              <placed-image :url="'contacts/' + contact.contact_id + '.jpg'"  />
              <div class="icon-panel">
                <a class="icon phone" :href="'tel:' + getTel(contact)" v-on:click="$k.sendAgentCallEvent(contact.name)"></a>
                <a class="icon mail" :href="'mailto:' + contact.email" v-on:click.prevent="handleEmailAgent(contact)"></a>
                <a class="icon linkedin" :href="contact.linked_in" v-show="contact.linked_in" rel="noopener" target="_blank"></a>
              </div>
            </div>
            <div class="pop-text">
              <div class="contact-name">
                <span class="bigname">{{ contact.name }}</span>
                <span class="jobtitle">{{ contact.title }}</span>
                <span class="code">{{ contact.code }}</span>
              </div>
              <div class="biography" v-html="contact.biography"></div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div v-if="showBios">
      <div v-for="contact in contacts" :key="'k2' + contact.contact_id" >
        <div>{{ contact.name }}</div>
        <div v-html="contact.biography"></div>
      </div>
    </div>
  </div>
</template>

<script>

import PlacedImage from '@/components/widgets/PlacedImage.vue'

const langOrder = {
  uk: 1,
  br: 2,
  sx: 3,
  us: 4,
  fr: 5,
  de: 6,
  cn: 7,
  au: 8,
  in: 9,
  sg: 10,
  zz: 11
}

function compareCode(code, code1) {
  return langOrder[code] - langOrder[code1]
}

export default {
  components: {
    PlacedImage
  },
  props: {
    region: null,
    columns: {
      type: Number,
      default: 5
    },
    showroll: Boolean,
    aboutPage: Boolean,
    agentsOnly: Boolean,
    hidetel: Boolean,
    agent: Object
  },
  data () {
    return {
      contacts: [],
      selcontact: 0,
      showBios: false
    }
  },
  
  created () {
    this.loadData()
  },
  mounted () {
    this.showBios = (this.$k.isPre() && this.aboutPage)
  },
  computed: {
    mcolumns () {
      if(this.agent) {
        return 2
      }
      return this.columns
    },
    lastNormalItem: function () {
      if(this.contacts.length > this.mcolumns) {
        if(this.contacts.length % this.mcolumns === 0){
          return (Math.floor(this.contacts.length / this.mcolumns) * this.mcolumns) - this.molumns;
        }
        return (Math.floor(this.contacts.length / this.mcolumns) * this.mcolumns);
      }
      return this.contacts.length
    }
  },
  methods: {
    getPopClass (index) {
      if(index < this.lastNormalItem) return ''
      if(this.columns === 3){
        return 'margin-top: -66%';
      }
      return 'margin-top:-57%';
    },
    showContact: async function (id) {
      if(this.selcontact > 0) {
        this.selcontact = 0
        await this.$k.waitfor(200)
      }
      this.selcontact = id
    },
    getTel(contact) {
      let dt = contact.locs[this.region]
      if(dt) {
        if(dt.tel) return dt.tel
      }
      return contact.tel
    },
    getAgentType(contact) {
      let dt = contact.locs[this.region]
      if(dt) {
        if(dt.agent_type) return dt.agent_type
      }
      return contact.tel
    },
    sendEvent (contact) {
      this.$k.sendAgentCallEvent( contact.name )
    },
    hideContact: function () {
      this.selcontact = 0
    },
    loadData: async function () {
      try {

        let res = await this.$apix.get(`collections/contacts/get/${this.$store.state.lang}`)
        let items = res.data
        let clang = this.$store.state.lang.toLowerCase()
        langOrder[clang] = 0;
        let atypes = ['Agent','Accounts']
        if(this.agentsOnly) [
          atypes = ['Agent']
        ]
        if(this.agent) {
          items = items.filter( el => el.contact_id === this.agent.contact_id)
        }
        else {
          if(this.region) {
            items = items.filter(el => { return ((el.locs[this.region]) && (atypes.includes(el.locs[this.region].agent_type))) } )
            items.sort((el, el1) => { return el.locs[this.region].rating - el1.locs[this.region].rating })
          }
          else {
            items.sort((el, el1) => { return compareCode(el.code, el1.code) || el.lname.localeCompare(el1.lname)})
          }
        }
        
        
        this.contacts = items
      }
      catch(err) {
        this.$k.messageBox('Connection error', 'Unable to load contacts data')
      }
      
    },
    handleEmailAgent(contact) {
      this.$k.sendAgentEmailEvent(contact.email)
      this.$emit('sendEmail', contact)
    }
  },
  watch: {
    '$store.state.lang': function () {
      this.loadData()
    },
    region: function () {
      this.loadData()
    },
    agent: function () {
      this.loadData()
    }
  }
}
</script>

<style>
.contacts-holder{
  display:flex;
  flex-wrap: wrap;
  align-items: stretch;
  
}
.contact-wrapper {
  position:relative;
  width:100%;
  height:100%;
  overflow:hidden;
}

.mini-contact-roll{
  opacity:0;
  position:absolute;
  box-sizing:border-box;
  left:0;
  bottom:0;
  background-color:rgba(255,255,255,0.8);
  padding:4%;
  width:100%;
  transition:all 0.3s ease;
  transform: translateY(100%);
}

.contact-wrapper:hover .mini-contact-roll{
  opacity:1;
  transform: translateY(1%);
}
.contact-block{
  width:20%;
  cursor:pointer;
}

.cols3 .contact-block{
  width:33.33%;
}

.cols2 .contact-block{
  width:50%;
}

.bgimage{
  width:100%;
  height:100%;
}

.contact-block .bgimage img{
  filter: grayscale(100%) brightness(85%);
}

.contact-block:hover .bgimage img, .contact-block.sel .bgimage img{
  filter: grayscale(0) brightness(105%)
}

.pop-info{
  position:absolute;
  width:100%;
  z-index:102;
  background-color:#fff;
  left:0;
  display:flex;
  cursor: default;
}

.pop-info .pop-image{
  width:30%;
}

.pop-info .pop-text{
  width:65%;
  box-sizing:border-box;
  padding:18px;
}

.pop-text .biography{
  font-size:14px;
  line-height:18px;
}

.contact-name{
  font-size:15px;
  margin-bottom:10px;
  margin-right:15px;
}

.contact-name .bigname{
  font-size:23px;
  color:#ce0e2d;
  font-weight:500;
  margin-right:10px;
}

.icon-panel{
  display:flex;
  justify-content:center;
  padding:10px;
  background-color:#a7aba122;
}

.icon-panel .icon{
  width:20%;
  background-position:center center;
  background-size:contain;
  height:20px;
  margin:5px;
  display:block;
}
.mini-contact-subpanel{
  display:flex;
  justify-content: space-between;
  align-items:center;
  color:#8b6f4b;
}
.mini-contact-subpanel a{
  color:#8b6f4b;
}
.mini-contact-subpanel a:hover{
  color:#ce0e2d;
}
.mini-name{
  font-weight:500;
  
}
.mini-contact-roll .icon{
  width:20%;
  background-position:center center;
  background-size:contain;
  height:18px;
  margin:5px;
  display:block;
}

.icon.phone{
  background-image:url('../../assets/img/phone.svg');
}

.icon.phone:hover{
  background-image:url('../../assets/img/phone-red.svg');
}

.icon.mail{
  background-image:url('../../assets/img/mail.svg');
}

.icon.mail:hover{
  background-image:url('../../assets/img/mail-red.svg');
}

.icon.linkedin{
  background-image:url('../../assets/img/linkedin-reverse.svg');
}

.icon.linkedin:hover{
  background-image:url('../../assets/img/linkedin-reverse-red.svg');
}

.contact-lightbox{
  position:fixed;
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.5);
  top:0;
  left:0;
  z-index:100;
  cursor:pointer;
}

.contact-name .code{
  text-transform: uppercase;
  color:#8b6f4b;
  margin-left:10px;
  font-size:13px;
  font-weight:500;
}

@media screen and (max-width:1300px){
  .mini-contact-roll{
    font-size:12px;
  }
  .mini-contact-roll .icon{
    height:15px;
  }
}

</style>
